/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 13:11:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/PageSetting/index.tsx
 */

import React from 'react';

import css from './css.module.less';

import { Input } from '@/src/components/Antd';
import { Field, antdErrorDisplayAdaptor } from 'src/components/RcForm';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { get } from 'lodash';
import {
  TimeAndDatePickerWithAlwaysOn,
  formatDateFromServer,
} from 'src/constrains/TimeAndDatePickField';
import {
  // alwaysOn,
  // beginDate,
  // beginTime,
  // endDate,
  // endTime,
  _timeSettings,
  name,
} from 'src/tools/contentModulesFieldName';

import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import {
  ALWAYS_ON,
  deconstructionDate,
} from 'src/constrains/TimeAndDatePickField/TimeAndDatePickerWithAlwaysOn';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { validateName, validateTime } from './validator';
const PageSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { status, timezoneInGmt, disabled } = props;

  const disableTimeSetting = status === 'InUse';

  return (
    <div className={css.container}>
      <Section>
        <ItemWrapper title={getI18n('general.pageName')}>
          <Field
            name={name}
            rules={[
              {
                // validateTrigger: 'onSubmit',
                validator: async (rules: any, value: any) => {
                  if (validateName) {
                    const res = validateName(value);

                    const hasError = get(res, 'hasError');
                    const errors = get(res, 'errors');
                    if (hasError) {
                      return Promise.reject(
                        new Error((errors || []).join(',')),
                      );
                      //</ItemWrapper>throw Error((errors || []).join(','));
                    }
                  }
                },
              },
            ]}>
            {(props, m) => {
              const eP = antdErrorDisplayAdaptor(m);
              return (
                <Input
                  maxLength={100}
                  size='large'
                  {...props}
                  {...m}
                  {...eP}
                  disabled={disabled}
                />
              );
            }}
          </Field>
        </ItemWrapper>
        <Field
          name={_timeSettings}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (validateTime) {
                  const res = validateTime(value);
                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, meta) => {
            const { value, onChange } = props;
            const { beginDate, beginTime, endDate, endTime, alwaysOn } =
              value || {};
            const _startTime = formatDateFromServer(beginDate, beginTime);
            const _endTime = formatDateFromServer(endDate, endTime);
            return (
              <TimeAndDatePickerWithAlwaysOn
                disableStartTime={disableTimeSetting}
                disabled={disabled}
                data={{
                  startTime: _startTime,
                  endTime: _endTime,
                  alwaysOn: alwaysOn,
                }}
                onTypeChange={({ type }) => {
                  if (type === ALWAYS_ON) {
                    onChange({
                      alwaysOn: true,
                      beginDate: null,
                      beginTime: null,
                      endDate: null,
                      endTime: null,
                    });
                  } else {
                    onChange({
                      alwaysOn: false,
                      beginDate,
                      beginTime,
                      endDate,
                      endTime,
                    });
                  }
                }}
                onDateChange={({
                  startTime: _startTime,
                  endTime: _endTime,
                }) => {
                  const { beginDate, beginTime, endDate, endTime } =
                    deconstructionDate(_startTime, _endTime);

                  onChange({
                    beginDate,
                    beginTime,
                    endDate,
                    endTime,
                    alwaysOn,
                  });
                }}
                timezone={timezoneInGmt}
              />
            );
          }}
        </Field>
        <Field
          shouldUpdate={(p, c) => {
            const pV = get(p, _timeSettings);
            const cV = get(c, _timeSettings);
            return pV !== cV;
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const value = get(props.value, _timeSettings);

            const res = validateTime(value);

            const hasError = get(res, 'hasError');
            const errors = get(res, 'errors') || [];
            return hasError ? <ErrorDisplay2 err={errors} hasError /> : null;
          }}
        </Field>
      </Section>
    </div>
  );
};
export default PageSetting;
